export const referAndEarnContent = {
  title: 'Refer and Earn',
  subtitle: 'Invite a friend to the club and earn 50 Zs when they complete their first visit.',

  howItWorks: {
    id: 'how-it-works',
    title: 'How it works',
    subtitle: 'Copy your referral code',
    content: [
      'Send a friend your unique referral code or link',
      'They enter this code when signing up to the club',
      `Once they've made their first visit, you receive 50 Zs!`,
    ],
  },
};
